export const image = {
  star: "/assets/images/cute-star-mascot.png",
  home: "/assets/images/design-cute/nav-overview.png",
  students: "/assets/images/design-cute/nav-students.png",
  points: "/assets/images/design-cute/nav-points.png",
  history: "/assets/images/design-cute/nav-history.png",
  monthly: "/assets/images/design-cute/nav-monthly.png",
  settings: "/assets/images/design-cute/nav-settings.png",
  classroom: "/assets/images/design-cute/nav-classroom.png",
  insights: "/assets/images/design-cute/nav-insights.png",
  counseling: "/assets/images/design-cute/nav-history.png",
  grades: "/assets/images/design-cute/nav-monthly.png",
  leaderboard: "/assets/images/design-cute/nav-leaderboard.png",
  growth: "/assets/images/design-cute/growth-sunflower.png",
  mascot: "/assets/images/design-cute/modal-mascot-bear-bunny-star.png",
  sport: "/assets/images/design-cute/preset-progress.png",
  hygiene: "/assets/images/design-cute/preset-broom.png",
  study: "/assets/images/design-cute/preset-book.png",
  discipline: "/assets/images/design-cute/preset-shield.png",
  manners: "/assets/images/design-cute/preset-heart.png",
  manual: "/assets/images/design-cute/preset-star.png",
  classroomSeat: "/assets/images/design-cute/classroom-seat-board.png",
  classroomRandom: "/assets/images/design-cute/classroom-random-jar.png",
  classroomTimer: "/assets/images/design-cute/shortcut-timer.png",
  classroomGroup: "/assets/images/design-cute/shortcut-group-game.png",
  emptyStudents: "/assets/images/design-cute/empty-students.png",
  statStar: "/assets/images/design-cute/stat-star.png",
  statFlower: "/assets/images/design-cute/stat-flower.png",
  statPeople: "/assets/images/design-cute/stat-people.png",
  statHeart: "/assets/images/design-cute/stat-heart.png",
  teacher: "/assets/images/design-cute/admin-shield.png",
  garden: "/assets/images/design-cute/auth-garden-scene.png",
  trophy: "/assets/images/design-cute/award-excellent-group.png",
  bell: "/assets/images/design-cute/icon-bell.png",
  mobileHome: "/assets/images/design-cute/mobile-nav-home.png",
  mobileStudents: "/assets/images/design-cute/mobile-nav-students.png",
  mobileProfile: "/assets/images/design-cute/mobile-nav-profile.png",
  mobileMore: "/assets/images/design-cute/mobile-nav-rank.png",
  historyNotebook: "/assets/images/design-cute/history-notebook.png",
  data: "/assets/images/design-cute/data-icon-database.png",
  navGroups: "/assets/images/design-cute/nav-groups.png",
  groupBadge: "/assets/images/design-cute/group-badge-sunflower.png",
  growthFlower: "/assets/images/design-cute/growth-flower.png",
  dockSign: "/assets/images/design-cute/dock-sign-wood.png",
  dockBunny: "/assets/images/design-cute/dock-mascot-bunny.png",
  dockBear: "/assets/images/design-cute/dock-mascot-bear.png",
  flagRainbow: "/assets/images/design-cute/modal-flag-rainbow.png",
  modalSad: "/assets/images/design-cute/modal-mascot-star-sad.png",
  modalConfirm: "/assets/images/design-cute/modal-mascot-bunny-peek.png",
  modalDanger: "/assets/images/design-cute/modal-mascot-bear-warning.png",
  modalForm: "/assets/images/design-cute/modal-mascot-sprout-large.png",
  modalPicker: "/assets/images/design-cute/modal-mascot-fox.png",
  modalSuccess: "/assets/images/design-cute/modal-mascot-bear-trophy.png",
  quickPlus1: "/assets/images/design-cute/overview-quick-plus1.png",
  quickPlus3: "/assets/images/design-cute/overview-quick-plus3.png",
  quickBell: "/assets/images/design-cute/overview-quick-bell.png",
  dockReward1: "/assets/images/design-cute/dock-reward-1.png",
  dockReward2: "/assets/images/design-cute/dock-reward-2.png",
  dockReward3: "/assets/images/design-cute/dock-reward-3.png",
  dockReward4: "/assets/images/design-cute/dock-reward-4.png",
  dockReward5: "/assets/images/design-cute/dock-reward-5.png",
  shortcutRandom: "/assets/images/design-cute/shortcut-random.png",
  shortcutReward: "/assets/images/design-cute/shortcut-reward-card.png",
  monthlyCertificate: "/assets/images/design-cute/monthly-certificate.png",
  laurel: "/assets/images/design-cute/modal-laurel-frame.png",
  podium: "/assets/images/design-cute/podium-scene.png",
  dataHappy: "/assets/images/design-cute/data-mascot-star-happy.png",
  dataCry: "/assets/images/design-cute/data-mascot-star-cry.png",
  growthPot: "/assets/images/design-cute/growth-pot.png"
} as const;

export const DESIGN_CUTE_PATH = "/assets/images/design-cute/";
export const DESIGN_CUTE_DB_PATH = "assets/images/design-cute/";

export function designCuteAsset(fileName: string) {
  return `${DESIGN_CUTE_PATH}${fileName}`;
}

export function growthStageAsset(theme: string, stage: number) {
  return designCuteAsset(`growth/${theme}-${stage}.png`);
}
